import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
});

$(window).on('load resize', function(){
  let headerSpHeight = $('.l-header-sp__inner').outerHeight();
  $('.l-drawer').css('padding-top', headerSpHeight);
});

const mvSwiper = new Swiper(".mv-swiper", {
  loop: true,
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 1000,
  allowTouchMove: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
});

const priceSwiper = new Swiper(".price-swiper", {
  loop: true,
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 1000,
  allowTouchMove: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
});

const instaSwiper = new Swiper(".insta-swiper", {
  loop: true,
  spaceBetween: 15,
  slidesPerView: 'auto',
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: ".p-home-insta .swiper-button-next",
    prevEl: ".p-home-insta .swiper-button-prev"
  },
  breakpoints: {
    768: {
      spaceBetween: 50,
    },
  }
});

$(function(){
	$(window).scroll(function (){
		$('.js-fade').each(function(){
			var pos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > pos - windowHeight + 100){
				$(this).addClass('js-scroll');
			}
		});
		$('.js-fade-slow').each(function(){
			var pos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > pos - windowHeight + 100){
				$(this).addClass('js-scroll');
			}
		});
	});
});